import { Component, EventEmitter, Input, Output, TemplateRef } from '@angular/core';

@Component({
  selector: 'app-button',
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.scss']
})
export class ButtonComponent {
  @Input() type: 'primary' | 'secondary' | 'danger' | 'success' | 'warning' | 'info' = 'primary';
  @Input() variant: 'solid' | 'gradient' | 'outline' = 'solid';
  @Input() size: 'sm' | 'md' | 'lg' = 'md';
  @Input() disabled: boolean = false;
  @Input() isLoading: boolean = false;
  @Input() buttonType: 'button' | 'submit' | 'reset' = 'button';
  @Input() fullWidth: boolean = false;
  @Input() icon?: TemplateRef<any> | null;
  @Input() iconPosition: 'left' | 'right' = 'left';
  @Input() customClasses?: string;
  @Output() onClick = new EventEmitter<Event>();

  get buttonClasses(): string {
    const baseClasses = 'btn';
    
    // Type classes with variant support
    const typeClasses: { [key: string]: string } = {
      'primary': this.variant === 'gradient' ? 'btn-gradient-primary' : (this.variant === 'outline' ? 'btn-outline-primary' : 'btn-primary'),
      'secondary': this.variant === 'outline' ? 'btn-outline-secondary' : 'btn-secondary',
      'danger': this.variant === 'gradient' ? 'btn-gradient-danger' : (this.variant === 'outline' ? 'btn-outline-danger' : 'btn-danger'),
      'success': this.variant === 'gradient' ? 'btn-gradient-success' : (this.variant === 'outline' ? 'btn-outline-success' : 'btn-success'),
      'warning': this.variant === 'gradient' ? 'btn-gradient-warning' : (this.variant === 'outline' ? 'btn-outline-warning' : 'btn-warning'),
      'info': this.variant === 'gradient' ? 'btn-gradient-info' : (this.variant === 'outline' ? 'btn-outline-info' : 'btn-info')
    };
    
    const sizeClasses = {
      'sm': 'btn-sm',
      'md': '',
      'lg': 'btn-lg'
    };
    
    const widthClass = this.fullWidth ? 'w-full' : '';
    const customClass = this.customClasses || '';

    return `${baseClasses} ${typeClasses[this.type]} ${sizeClasses[this.size]} ${widthClass} ${customClass}`.trim();
  }

  get hasIcon(): boolean {
    return !!this.icon;
  }

  handleClick(event: Event): void {
    if (!this.disabled && !this.isLoading) {
      this.onClick.emit(event);
    }
  }
} 